import { Route, Routes } from "react-router-dom";

import { InvalidLinkScreen } from "../components/InvalidLinkScreen";
import { CartPage } from "../pages/CartPage";
import { CatalogPage } from "../pages/CatalogPage";
import { CheckoutPage } from "../pages/CheckoutPage";
import { CheckoutSuccessPage } from "../pages/CheckoutSuccessPage";
import { OrderDetailPage } from "../pages/OrderDetailPage";
import { OrdersPage } from "../pages/OrdersPage";
import { ProductPage } from "../pages/ProductPage";
import { ShopGuard } from "./ShopGuard";

/**
 * AppRoutes — карта витрины из docs/07-miniapp-ux.md §2. Всё живёт за ShopGuard
 * (аутентификация по slug из /s/<slug>); открытие без слага — InvalidLinkScreen.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/s/:slug" element={<ShopGuard />}>
        <Route index element={<CatalogPage />} />
        <Route path="product/:productId" element={<ProductPage />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="orders/:orderId" element={<OrderDetailPage />} />
      </Route>
      <Route path="*" element={<InvalidLinkScreen />} />
    </Routes>
  );
}
